<template>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-12">
      <b-overlay :show="isLoading" class="rounded" variant="transparent">
        <template #overlay>
          <b-img
            width="100"
            :src="require('@/assets/img/brand/loader.gif')"
            alt=""
          />
        </template>
        <div class="card bg-secondary shadow border-0 rounded">
          <div class="card-header bg-transparent pb-2">
            <div class="text-muted text-center mt-2 mb-1">
              <h3>{{ $t("sign_up") }}</h3>
              <img src="favicon.png" class="icon-app" alt="" />
            </div>
          </div>
          <div class="card-body px-lg-5 py-lg-4">
            <form @submit.prevent>
              <b-row>
                <b-col :md="6" :sm="12" v-if="ref_status">
                  <base-input
                    :label="$t('referrer')"
                    :placeholder="$t('referrer')"
                    input-classes="form-control-alternative border"
                    v-model="model.referrer"
                    data-vv-validate-on="blur"
                    v-validate="''"
                    :data-vv-as="$t('referrer')"
                    name="referrer"
                    autocomplete="off"
                  />
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('name')"
                    :placeholder="$t('name')"
                    input-classes="form-control-alternative border"
                    v-model="model.name"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('name')"
                    name="name"
                    autocomplete="off"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('name')"
                    ><small>{{ errors.first("name") }}</small></span
                  >
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('lastname')"
                    :placeholder="$t('lastname')"
                    input-classes="form-control-alternative border"
                    v-model="model.lastname"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('lastname')"
                    name="lastname"
                    autocomplete="off"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('lastname')"
                    ><small>{{ errors.first("lastname") }}</small></span
                  >
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('nickname')"
                    :placeholder="$t('nickname')"
                    input-classes="form-control-alternative border"
                    v-model="model.nickname"
                    data-vv-validate-on="blur"
                    v-validate="'required'"
                    :data-vv-as="$t('nickname')"
                    name="nickname"
                    autocomplete="off"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('nickname')"
                    ><small>{{ errors.first("nickname") }}</small></span
                  >
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('email')"
                    :placeholder="$t('email')"
                    input-classes="form-control-alternative border"
                    v-model="model.email"
                    data-vv-validate-on="blur"
                    v-validate="'required|email'"
                    :data-vv-as="$t('email')"
                    name="email"
                    autocomplete="off"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('email')"
                    ><small>{{ errors.first("email") }}</small></span
                  >
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('password')"
                    :placeholder="$t('password')"
                    input-classes="form-control-alternative border"
                    v-model="model.password"
                    data-vv-validate-on="blur"
                    v-validate="'required|min:8|max:20'"
                    :data-vv-as="$t('password')"
                    name="password"
                    ref="password"
                    autocomplete="off"
                    type="password"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password')"
                    ><small>{{ errors.first("password") }}</small></span
                  >
                </b-col>
                <b-col md="6">
                  <base-input
                    :label="$t('password_confirmation')"
                    :placeholder="$t('password_confirmation')"
                    input-classes="form-control-alternative border"
                    v-model="model.password_confirmation"
                    data-vv-validate-on="blur"
                    v-validate="'required|min:8|max:20|confirmed:password'"
                    :data-vv-as="$t('password_confirmation')"
                    name="password_confirmation"
                    autocomplete="off"
                    type="password"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password_confirmation')"
                    ><small>{{
                      errors.first("password_confirmation")
                    }}</small></span
                  >
                </b-col>
                <b-col md="12">
                  <b-form-checkbox
                    switch
                    class="ml-3"
                    size="sm"
                    v-model="status"
                  >
                    {{ $t("question_wallet") }}
                  </b-form-checkbox>

                  <base-input
                    v-if="status"
                    :label="$t('wallet')"
                    :placeholder="$t('wallet')"
                    input-classes="form-control-alternative border"
                    v-model="model.wallet"
                    data-vv-validate-on="blur"
                    v-validate="'required|min:26|max:45'"
                    :data-vv-as="$t('wallet')"
                    name="wallet"
                    autocomplete="off"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('wallet')"
                    ><small>{{ errors.first("wallet") }}</small></span
                  >
                </b-col>
              </b-row>

              <div class="text-center">
                <base-button
                  type="primary"
                  class="my-4 float-right"
                  @click="validate()"
                  >{{ $t("sign_up") }}</base-button
                >
                <router-link
                  class="btn btn-secondary float-right my-4 mr-2"
                  to="/login"
                >
                  {{ $t("back") }}
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </b-overlay>
      <div class="row mt-3">
        <div class="col-5">
          <router-link to="/forgot-password" class="text-light">
            <small> {{ $t("forgot_password") }}</small>
          </router-link>
        </div>
        <div class="col-7 text-right">
          <router-link to="/login" class="text-light">
            <small> {{ $t("into_login") }}</small>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import helpers from "@/services/helpers";
export default {
  name: "register",
  created() {
    if (localStorage.getItem("ref")) {
      this.model.referrer = localStorage.getItem("ref");
    }
  },
  watch: {
    status() {
      this.status === false ? (this.model.wallet = "") : "";
    },
  },
  data() {
    return {
      model: {
        name: "",
        lastname: "",
        nickname: "",
        email: "",
        password: "",
        password_confirmation: "",
        referrer: "",
        wallet: "",
      },
      ref_status: false,
      status: false,
    };
  },
  methods: {
    ...mapActions({ userRegister: "register" }),
    async register() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        const res = await this.userRegister(this.model);
        if (res.status === 200) {
          localStorage.removeItem("ref");
          this.$toast.success(this.$t("message_register"), {
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
    async validate() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        localStorage.getItem("ref") ? this.msgConfirm() : this.register();
      }
    },
    msgConfirm() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          this.model.referrer
            ? `${this.$t("message_confirm_referrer")} ${this.model.referrer}`
            : `${this.$t("not_referrer")}`,
          {
            title: this.$t("please_confirm_referrer"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("not"),
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          value ? this.register() : (this.ref_status = true);
        })
        .catch((err) => {
          helpers.handleError(err);
        });
    },
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
  },
};
</script>
<style scope>
.icon-app {
  max-height: 7rem;
}
</style>
